<template>
  <div>
    <div style="height: 50px;">
      <span style="float: right">
        <el-switch
            v-if="checkStatus ==1 || checkStatus ==2 "
            :width="50"
            class="mr10 fl mt10"
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value=2
            :inactive-value=1
            @change="checkPass(checkStatus)"
        >
      </el-switch>
      <el-switch
          v-if="checkStatus ==3 || checkStatus ==4 "
          :width="50"
          class="mr10 fl mt10"
          v-model="checkStatus"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value=4
          :inactive-value=3
          @change="checkPass(checkStatus)"
      >
      </el-switch>
      <el-switch
          v-if="checkStatus ==0"
          :width="50"
          class="mr10 fl mt10"
          v-model="checkStatus"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value=2
          :inactive-value=0
          @change="checkPass(checkStatus)"
      >
      </el-switch>
        <el-button v-if="checkStatus == 1" type="text"  >
        <el-tooltip class="item" effect="dark" :content="checkResult | result" placement="top">
          <span>原因</span>
        </el-tooltip>
      </el-button>
      </span>
    </div>
    <div v-show='videoType == "OPEN"'>
      <video id="videobox" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls preload="auto" webkit-playsinline="true" playsinline="true" type="application/x-mpegURL" allowsInlineMediaPlayback=YES  webview.allowsInlineMediaPlayback=YES  width='100%' ref='videoRef' x5-video-player-fullscreen="true" :poster="posterSrc" >
        <source id="sourceBox" :src="videoSrc" type="video/mp4">
        <p class="vjs-no-js">不支持播放</p>
      </video>
    </div>
    <div v-show='videoType == "VOD"'>
      <ali-player v-if="loaded"  ref="player"
                  :vid = 'vid'
                  :playauth="playAuth"
                  width="100%"
                  height="500px"
                  :encryptType = 'encryptType'
      ></ali-player>
    </div>
  </div>
  
</template>

<script>
  import videojs from 'video.js';
  import 'video.js/dist/video-js.css';
  import https from '@/https.js';
  import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  export default {
    name: 'VideoReview',
    props: ['courseId','catalogId','resourceType','resourceId'],
    components: {
      "ali-player": AliPlayer
    },
    data() {
      return {
        videoType: '',
        loginOrgCode: '',
        loaded: false,
        videoType: 0,
        vid: '',
        playAuth: '',
        encryptType: 1,
        useH5Prism: true,
        playsinline: true,
        controlBarVisibility: 'hover',
        format: 'm3u8',
        src: 'https://live.eblcu.cn/',
        url: 'rtmp://live.teblcu.com/EblcuFMSVideo/mp4:english3/video/dcdst01.mp4',
        version: 'player.v2.swf',
        _parm: '',
        isAutoStart: 'true',
        isOldAddress: 'true',
        isRtmp: false,
        videoSrc:'',
        posterSrc:'',
        isError:false,
        checkStatus: '',
        rtmpParam: {
          data: '',
          movie: '',
        }
      };
    },
    mounted() {
      
      setTimeout(() => {   //延时确保能监听到视频源错误
        let myPlayer = videojs("videobox", {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: "muted",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "800px",
          //设置视频播放器的显示高度（以像素为单位）
          height: "400px"
        });
      },1000);
      
      // player.width(this.videoW)   //设置播放器宽度
    },
    methods: {
      getAliUrl(videoInfoId) {
        let params = {
          videoInfoId: videoInfoId
        };
        this.https.fetchPost('/videoInfo/getVODPlayAuth', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let playAuth = data.data.data.data.playAuth;
            let videoId = data.data.data.data.videoMeta.videoId;
            this.playAuth = playAuth;
            this.vid = videoId;
            console.log(videoId)
            this.loaded = true;
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
      parm(url, mediaURL) {
        this._parm ='?';
        this._parm +='url='+url+'&&';
        this._parm +='filename='+mediaURL+'&&';
        this._parm +='isAutoStart='+this.isAutoStart+'&&';
        this._parm +='isOldAddress='+this.isOldAddress+'&&';
      },

      checkPass(checkStatus) {

        if(checkStatus == 1) {
          this.checkStatus = 3;
        }

        if(checkStatus == 2) {
          this.checkStatus = 4;
        }

        let params = { // 0 目录 1资源
          courseId: this.courseId,
          resourceId: this.resourceId,
          resourceType: 1,
          checkStatus: this.checkStatus
        };
        https.fetchPost('/courseCheck/checkPass',params ,"json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '操作失败:'+msg
            });
          }
        }).catch(err=>{
              console.log(err)
            }
        )
      },
      getPlayUrl() {
        let params = {
          catalogId: this.catalogId,
          type: "T"
        }
        
        https.fetchPost('/question/beginStudy', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.videoType = data.data.data.videoType;
            if(data.data.data.videoType == 'OPEN') {
              this.videoSrc = data.data.data.data.url;
            } else {
              let playAuth = data.data.data.data.playAuth;
              let videoId = data.data.data.data.videoMeta.videoId;
              this.playAuth = playAuth;
              this.vid = videoId;
              console.log(videoId)
              this.loaded = true;
            }
            // this.videoSrc = "https://oescdn.open.com.cn/testyf/VE/DATA/2019/0926/VEewyknDATA20190926110637763.mp4?Expires=1574492339&OSSAccessKeyId=81kgc0VJPbZ4WnpN&Signature=CACTPu98YJh8ZWynuioBHpmAaUQ%3D";
            
            this.checkStatus = data.data.data.checkStatus;
            console.log(this.checkStatus)
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
      getResource() {
        let params = {
          "catalogId":this.catalogId
        }
        https.fetchPost('/resources/get', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.checkStatus = data.data.data.checkStatus;
            this.checkResult = data.data.data.checkResult;
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
    },
    filters: {
      result(val) {
        return "视频内容"+val;
      }
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.getResource();
      this.getPlayUrl();
    },
    beforeDestroy(){
      const videoDom = this.$refs.videoRef;   //不能用document 获取节点
      videojs(videoDom).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
    }
    
    
  };
</script>

<style scoped>

</style>
